import { render, staticRenderFns } from "./ManageBalance.vue?vue&type=template&id=53200230&"
import script from "./ManageBalance.vue?vue&type=script&lang=js&"
export * from "./ManageBalance.vue?vue&type=script&lang=js&"
import style0 from "./ManageBalance.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports